import indefinite from 'indefinite';

export const getArticle = (word: string): string => indefinite(word);
